import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import AddContactButton from 'src/components/Control/Buttons/AddContactButton';
import DeleteContactButton from 'src/components/Control/Buttons/DeleteContactButton';
import MergeContactMenubutton from 'src/components/Control/Buttons/MergeContactMenuButton';
import EditContactButton from 'src/components/Control/Buttons/EditContactButton';
import SelectAllMenubutton from 'src/components/Control/Buttons/SelectAllMenuButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import ShowInvoicesForContactButton from 'src/components/Control/Buttons/ShowInvoicesForContactButton';
import ShowPaymentsForContactButton
  from 'src/components/Control/Buttons/ShowPaymentsForContactButton';
import DownloadContactButton from 'src/components/Control/Buttons/DownloadContactButton';

const ContactToolbar = () => {
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.contacts] || [],
  );

  return (
    <>
      <AddContactButton />
      <EditContactButton
        disabled={!selections.length} />
      <DeleteContactButton
        disabled={!selections.length} />
      <MergeContactMenubutton
        disabled={selections.length !== 2} />
      <ConfigureColumnsButton
        entity={ENTITIES.contacts} />
      <UnselectAllMenubutton
        entity={ENTITIES.contacts}
        disabled={!selections.length} />
      <SelectAllMenubutton
        entity={ENTITIES.contacts} />
      <ShowInvoicesForContactButton
        disabled={selections.length !== 1}
        contactId={selections[0]} />
      <ShowPaymentsForContactButton
        disabled={selections.length !== 1}
        contactId={selections[0]} />
      <DownloadContactButton />
    </>
  );
};
export default ContactToolbar;
//
